import React from 'react'
import Page from 'components/Page'
import PageTitle from 'components/Page/Page.Title'
import PageSubTitle from 'components/Page/Page.SubTitle'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import useDispatch from 'modules/component/utils/hooks/useDispatch'
import useSelector from 'modules/component/utils/hooks/useSelector'
import { View } from 'components/View'
import Block from 'components/Block'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import pushRouterAction from 'modules/router/actions/push'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { useTheme } from 'modules/styles'
import logEventAnalyticsUtil from 'modules/analytics/utils/log-event'
import { FEATURE_NAME_TO_IMAGE_SOURCE } from 'modules/app/constants/features'
import ToolCard from './components/ToolCard'
import { ToolsFAQ } from './components/ToolsFAQ'

const messages = defineMessages({
  title: {
    id: 'ToolsPage.title',
    defaultMessage: 'Fitness Tools - Gymaholic'
  },
  headline: {
    id: 'ToolsPage.headline',
    defaultMessage: 'Fitness Tools'
  },
  description: {
    id: 'ToolsPage.description',
    defaultMessage: 'Powerful AI-powered fitness tools to help you move, eat and live better.'
  },
  checkExerciseFormTitle: {
    id: 'ToolsPage.checkExerciseFormTitle',
    defaultMessage: 'Check Exercise Form'
  },
  checkExerciseFormDescription: {
    id: 'ToolsPage.checkExerciseFormDescription',
    defaultMessage: 'Upload a video of your exercise and get instant AI feedback on your form, posture, and technique.'
  },
  tryIt: {
    id: 'ToolsPage.tryIt',
    defaultMessage: 'Try It'
  }
})

const ANALYTIC_EVENT = {
  TOOLS_CHECK_EXERCISE_FORM_CLICK: 'TOOLS_CHECK_EXERCISE_FORM_CLICK'
}

export default function ToolsPage () {
  const intl = useIntl()
  const dispatch = useDispatch()
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const theme = useTheme()

  const handleCheckExerciseFormClick = () => {
    // Analytics
    logEventAnalyticsUtil(ANALYTIC_EVENT.TOOLS_CHECK_EXERCISE_FORM_CLICK)

    dispatch(pushRouterAction({ pathname: ROUTE_PATH.TOOLS_CHECK_EXERCISE_FORM }))
  }

  return (
    <Page
      shouldNotHavePadding
      title={formatMessageIntlUtil(intl, messages.title)}
    >
      <Block
        style={{
          minHeight: 'auto',
          flexGrow: '1',
          padding: isSmallScreen
            ? '1.5rem 2rem 8rem'
            : '4rem 8rem 18rem'
        }}
      >
        <View centered>
          {/* Page Title */}
          <View>
            <PageTitle>
              {formatMessageIntlUtil(intl, messages.headline)}
            </PageTitle>
          </View>

          {/* Page Description */}
          <View mt>
            <PageSubTitle style={{ textAlign: 'center' }}>
              {formatMessageIntlUtil(intl, messages.description)}
            </PageSubTitle>
          </View>

          {/* Tools Grid */}
          <View
            mt={2}
            row={!isSmallScreen}
            style={{
              gap: isSmallScreen ? '1rem' : '2rem',
              width: '100%',
              maxWidth: '420px'
            }}
          >
            <ToolCard
              title={formatMessageIntlUtil(intl, messages.checkExerciseFormTitle)}
              description={formatMessageIntlUtil(intl, messages.checkExerciseFormDescription)}
              imageSource={FEATURE_NAME_TO_IMAGE_SOURCE.CHECK_YOUR_FORM_WITH_VIDEO}
              ctaText={formatMessageIntlUtil(intl, messages.tryIt)}
              onClick={handleCheckExerciseFormClick}
            />
          </View>
        </View>
      </Block>

      {/* FAQ Section */}
      <ToolsFAQ />
    </Page>
  )
}
